import { render, staticRenderFns } from "./spareParts.vue?vue&type=template&id=b2c569ac&scoped=true&"
import script from "./spareParts.vue?vue&type=script&lang=js&"
export * from "./spareParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c569ac",
  null
  
)

export default component.exports